<template>
  <v-col class="pa-0">
    <v-text-field
      id="filter_value"
      v-model="value"
      type="text"
      :label="$t('value')"
      dense
    />
    <v-row>
      <v-col cols="6">
        <v-btn
          v-if="value !== ''"
          color="red"
          @click="doRemoveFilter"
        >
          {{ $t('clear') }}
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
          v-if="value !== ''"
          color="blue"
          @click="doSetFilter"
        >
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  export default {
    props: {
      filterName: {
        type: String,
        default: '',
      },
      filterValue: {
        type: String,
        default: '',
      },
      setFilter: {
        type: Function,
        default: (val) => console.log(val),
      },
    },
    data () {
      return {
        value: '',
      }
    },
    mounted: function () {
      this.value = this.filterValue
    },
    methods: {
      doSetFilter: function () {
        this.$emit('filter-added', {
          [this.filterName]: this.value,
        })
      },
      doRemoveFilter: function () {
        this.$emit('filter-remove', this.filterName)
      },
      clearFilter: function () {
        this.value = ''
        this.doRemoveFilter()
      },
    },
  }
</script>
